import { CSSProperties } from "react"
import { useNavigate } from "react-router-dom"
import { useSession } from "../../auth/session"
import { useUserProfile } from "../../redux/profilesSlice"
import Avatar from "./Avatar"

// The common user display for lists and cards: avatar + username in the
// standard link blue (never the row title's bold), full name as the tooltip
// when known; clicking navigates to the user's page. Rows that already carry
// profile data pass `user`; without it the profile is fetched through the
// cached profiles slice (the old OwnerChip behavior — this widget replaced
// it).
export default function UserChip({ userId, user, style }: {
  userId: string
  user?: { firstname?: string, lastname?: string, imageUrl?: string }
  style?: CSSProperties
}) {
  if (user !== undefined)
    return <ChipView userId={userId} user={user} style={style} />
  return <FetchedChip userId={userId} style={style} />
}

function FetchedChip({ userId, style }: { userId: string, style?: CSSProperties }) {
  const session = useSession()
  const { data: user } = useUserProfile(userId, session.accessToken ?? "")
  return <ChipView userId={userId} user={user} style={style} />
}

function ChipView({ userId, user, style }: {
  userId: string
  user?: { firstname?: string, lastname?: string, imageUrl?: string }
  style?: CSSProperties
}) {
  const navigate = useNavigate()
  const name = [user?.firstname, user?.lastname].filter(Boolean).join(" ")
  return (
    <span
      className="user-chip"
      title={name || undefined}
      onClick={(e) => { e.stopPropagation(); navigate(`/users/${userId}`) }}
      style={style}
    >
      <Avatar imageUrl={user?.imageUrl} size={20} />
      {userId}
    </span>
  )
}
